/* ATLEQS Custom Cards JS v27 - 2026-07-14 - Systempfleger fuer Shopify
   Spec: #2957/23679+23676+23682+23734+23753. Komplett-Neuaufbau (sauber, parse-getestet).
   Karten: Swatches/Groessen -> Preis-Update + Detail-Link; Icon -> Dawn-Popup (Vorauswahl via ?variant).
   Popup: ruhige Varianten-Updates ohne Dawn-Rerender, Soldout-Markierung, Lightbox, Link-Patch. */
(function () {
  var COLORS = {
    'schwarz': '#121212', 'weiss': '#ffffff', 'wei\u00df': '#ffffff', 'grau': '#8a8a8a',
    'rot': '#de2a2a', 'blau': '#3b6bd6', 'marine': '#1f2a44', 'navy': '#1f2a44',
    'gruen': '#3f7f4e', 'gr\u00fcn': '#3f7f4e', 'olive': '#6b6b3a', 'gelb': '#e8d84a',
    'orange': '#e58a3a', 'rosa': '#e9a7c0', 'pink': '#e05c8f', 'lila': '#8a5fbf',
    'violett': '#8a5fbf', 'braun': '#7a4b2e', 'beige': '#d9c7a7', 'creme': '#f2e8d5',
    'tuerkis': '#39b0af', 't\u00fcrkis': '#39b0af', 'bordeaux': '#7b1e3c', 'khaki': '#8a7f4e', 'siyah': '#121212', 'beyaz': '#ffffff', 'bej': '#d9c7a7', 'gri': '#8a8a8a', 'lacivert': '#1f2a44', 'donanma': '#1f2a44', 'kirmizi': '#de2a2a', 'mavi': '#3b6bd6', 'yesil': '#3f7f4e', 'sari': '#e8d84a', 'pembe': '#e9a7c0', 'mor': '#8a5fbf', 'kahverengi': '#7a4b2e', 'turuncu': '#e58a3a', 'black': '#121212', 'white': '#ffffff', 'grey': '#8a8a8a', 'gray': '#8a8a8a', 'red': '#de2a2a', 'blue': '#3b6bd6', 'green': '#3f7f4e', 'yellow': '#e8d84a', 'pink': '#e9a7c0', 'purple': '#8a5fbf', 'brown': '#7a4b2e'
  };
  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) + ' EUR';
  }
  function paintSwatches(root) {
    (root || document).querySelectorAll('.atleqs-swatch span[data-color]').forEach(function (el) {
      var c = COLORS[el.getAttribute('data-color')];
      if (c) { el.style.background = c; if (c === '#ffffff') el.style.boxShadow = 'inset 0 0 0 1px rgba(18,18,18,.2)'; }
    });
  }
  function cardOf(el) { return el.closest('.card-wrapper'); }
  function getData(card) {
    var s = card ? card.querySelector('script.atleqs-data') : null;
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function selection(card) {
    var sel = {};
    var sw = card.querySelector('.atleqs-swatch.is-active');
    var sz = card.querySelector('.atleqs-size.is-active');
    if (sw) sel[card.querySelector('.atleqs-swatches').getAttribute('data-opt-pos')] = sw.getAttribute('data-value');
    if (sz) sel[card.querySelector('.atleqs-sizes').getAttribute('data-opt-pos')] = sz.getAttribute('data-value');
    return sel;
  }
  function updateCard(card) {
    var data = getData(card); if (!data) return;
    var sel = selection(card);
    var match = data.filter(function (v) {
      return Object.keys(sel).every(function (pos) { return String(v['o' + pos]) === sel[pos]; });
    });
    var best = match.find(function (v) { return v.a; }) || match[0];
    if (!best) return;
    var atc = card.querySelector('.atleqs-atc');
    if (atc) atc.setAttribute('data-variant-id', best.id);
    if (atc) atc.classList.toggle('atleqs-atc-off', !match.some(function (v) { return !!v.a; }));
    var priceWrap = card.querySelector('.price');
    if (priceWrap) {
      var saleEl = priceWrap.querySelector('.price-item--sale');
      var regEls = priceWrap.querySelectorAll('.price-item--regular');
      if (saleEl) saleEl.textContent = euro(best.p);
      regEls.forEach(function (r) { r.textContent = euro(best.c && best.c > best.p ? best.c : best.p); });
    }
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try { var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('variant', best.id); a.setAttribute('href', u.pathname + u.search); } catch (err) {}
    });
    var det = card.querySelector('.atleqs-detail');
    var both = card.querySelector('.atleqs-swatch.is-active') && card.querySelector('.atleqs-size.is-active');
    if (det) det.classList.toggle('is-visible', !!both);
    markSoldout(card);
  }
  function markSoldout(card) {
    var data = getData(card); if (!data) return;
    [['.atleqs-swatches', '.atleqs-swatch', '.atleqs-sizes', '.atleqs-size'], ['.atleqs-sizes', '.atleqs-size', '.atleqs-swatches', '.atleqs-swatch']].forEach(function (cfg) {
      var wrap = card.querySelector(cfg[0]); if (!wrap) return;
      var pos = wrap.getAttribute('data-opt-pos');
      var oWrap = card.querySelector(cfg[2]);
      var oAct = oWrap ? oWrap.querySelector(cfg[3] + '.is-active') : null;
      var oPos = oWrap ? oWrap.getAttribute('data-opt-pos') : null;
      wrap.querySelectorAll(cfg[1]).forEach(function (b) {
        var val = b.getAttribute('data-value');
        var any = data.some(function (v) {
          if (String(v['o' + pos]) !== val) return false;
          if (oAct && String(v['o' + oPos]) !== oAct.getAttribute('data-value')) return false;
          return !!v.a;
        });
        b.classList.toggle('atleqs-soldout', !any);
      });
    });
  }
  function refreshCartBadge() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
      if (bubble) { bubble.textContent = cart.item_count; }
    });
  }
  function openLightbox(mw) {
    var im = mw.querySelector('img'); if (!im) return;
    var lb = document.createElement('div'); lb.className = 'atleqs-lightbox';
    var big = document.createElement('img'); big.src = im.currentSrc || im.src; lb.appendChild(big);
    var x = document.createElement('button'); x.className = 'atleqs-lightbox-close'; x.textContent = '\u2715'; lb.appendChild(x);
    lb.addEventListener('click', function (e2) { if (e2.target === lb || e2.target === x) { e2.stopPropagation(); lb.remove(); } });
    document.body.appendChild(lb);
  }
  function patchModalLinks(modal) {
    var idInp = modal.querySelector('form [name="id"]');
    if (!idInp || !idInp.value) return;
    modal.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try { var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('variant', idInp.value); a.setAttribute('href', u.pathname + u.search); } catch (err) {}
    });
  }
  function dataForModal(modal) {
    var a = modal.querySelector('a[href*="/products/"]');
    var handle = null;
    if (a) { var mm = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/); if (mm) handle = mm[1]; }
    if (handle) {
      var cards = document.querySelectorAll('.card-wrapper');
      for (var i = 0; i < cards.length; i++) {
        var la = cards[i].querySelector('a[href*="/products/' + handle + '"]');
        if (la && cards[i].querySelector('script.atleqs-data')) return getData(cards[i]);
      }
    }
    var idInp = modal.querySelector('form [name="id"]');
    if (idInp && idInp.value) {
      var all = document.querySelectorAll('script.atleqs-data');
      for (var j = 0; j < all.length; j++) {
        try { var d = JSON.parse(all[j].textContent); if (d.some(function (v) { return String(v.id) === idInp.value; })) return d; } catch (e2) {}
      }
    }
    return null;
  }
  function updLegend(fs, lg) {
    var ch = fs.querySelector('input:checked');
    var sp = lg.querySelector('.atleqs-legend-val');
    if (ch && sp) { var t = ': ' + ch.value; if (sp.textContent !== t) sp.textContent = t; }
  }
  function quietUpdate(modal) {
    var data = dataForModal(modal); if (!data) return;
    var fs = Array.prototype.slice.call(modal.querySelectorAll('fieldset'));
    fs.forEach(function (f) { var lg = f.querySelector('legend'); if (lg) updLegend(f, lg); });
    var sel = fs.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
    if (fs[1]) {
      fs[1].querySelectorAll('label').forEach(function (l) {
        var i2 = l.htmlFor ? document.getElementById(l.htmlFor) : null;
        var v = data.find(function (x) { return x.o1 === sel[0] && x.o2 === (i2 ? i2.value : null); });
        l.classList.toggle('atleqs-soldout', !!(v && !v.a));
      });
    }
    var best = data.find(function (v) { return (sel[0] == null || v.o1 === sel[0]) && (sel[1] == null || v.o2 === sel[1]); });
    if (!best) return;
    var idInp = modal.querySelector('form [name="id"]');
    if (idInp) idInp.value = best.id;
    var pw = modal.querySelector('.price');
    if (pw) {
      var saleEl = pw.querySelector('.price-item--sale');
      var regs = pw.querySelectorAll('.price-item--regular');
      if (saleEl) saleEl.textContent = euro(best.p);
      regs.forEach(function (r) { r.textContent = euro(best.c && best.c > best.p ? best.c : best.p); });
    }
    var btn = modal.querySelector('.product-form__submit');
    if (btn) {
      if (best.a) { btn.removeAttribute('disabled'); } else { btn.setAttribute('disabled', ''); }
      var sp = btn.querySelector('span');
      if (sp) { var t2 = best.a ? 'In den Warenkorb legen' : 'Ausverkauft'; if (sp.textContent.trim() !== t2) sp.textContent = t2; }
    }
    patchModalLinks(modal);
  }
  function decorateQuickAdd() {
    document.querySelectorAll('quick-add-modal').forEach(function (modal) {
      modal.querySelectorAll('fieldset').forEach(function (fs) {
        var lg = fs.querySelector('legend');
        if (!lg) return;
        var nm = (lg.childNodes[0] ? lg.childNodes[0].textContent : lg.textContent).trim().toLowerCase();
        var labels = Array.prototype.slice.call(fs.querySelectorAll('label'));
        if (nm.indexOf('farbe') === 0 || nm.indexOf('color') === 0 || nm.indexOf('renk') === 0) {
          labels.forEach(function (l) {
            if (!l.classList.contains('atleqs-pswatch')) {
              l.classList.add('atleqs-pswatch');
              var inp0 = l.htmlFor ? document.getElementById(l.htmlFor) : null;
              var val = ((inp0 ? inp0.value : l.textContent) || '').trim().toLowerCase();
              var col = COLORS[val];
              l.style.background = col || '#cfcfcf';
              if (col === '#ffffff') l.style.boxShadow = 'inset 0 0 0 1px rgba(18,18,18,.25)';
              l.title = (l.textContent || '').trim();
            }
          });
        } else if (nm.indexOf('gr') === 0 || nm.indexOf('size') === 0 || nm.indexOf('boyut') === 0 || nm.indexOf('beden') === 0) {
          labels.forEach(function (l) { l.classList.add('atleqs-psize'); });
        } else { return; }
        if (!lg.querySelector('.atleqs-legend-val')) {
          var sp = document.createElement('span');
          sp.className = 'atleqs-legend-val';
          lg.appendChild(sp);
        }
        updLegend(fs, lg);
      });
      var mw = modal.querySelector('.product__media-wrapper');
      if (mw && !mw.classList.contains('atleqs-thumb')) {
        mw.classList.add('atleqs-thumb');
      }
      if (!modal.hasAttribute('data-atleqs-hooked')) {
        modal.setAttribute('data-atleqs-hooked', '1');
        var atqStop = function (ev) {
          var inp = ev.target;
          if (!inp || inp.type !== 'radio') return;
          if (!dataForModal(modal)) return;
          ev.stopImmediatePropagation();
          ev.stopPropagation();
          if (ev.type === 'change') { quietUpdate(modal); }
        };
        modal.addEventListener('change', atqStop, true);
        modal.addEventListener('input', atqStop, true);
      }
      quietUpdate(modal);
    });
  }
  var pdpCache = null;
  function quietUpdatePdp() {
    var wrap = document.querySelector('.product__info-wrapper');
    if (!wrap) return;
    var done = function (pj) {
      var fs = Array.prototype.slice.call(wrap.querySelectorAll('fieldset'));
      fs.forEach(function (f) { var lg = f.querySelector('legend'); if (lg) updLegend(f, lg); });
      var sel = fs.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
      var best = pj.variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        for (var oi = 0; oi < fs.length; oi++) { if (sel[oi] != null && opts[oi] !== sel[oi]) return false; }
        return true;
      });
      fs.forEach(function (f, fi) {
        f.querySelectorAll('label').forEach(function (l) {
          var i2 = l.htmlFor ? document.getElementById(l.htmlFor) : null;
          if (!i2) return;
          var ok = pj.variants.some(function (v) {
            var opts = [v.option1, v.option2, v.option3];
            if (opts[fi] !== i2.value) return false;
            for (var oi = 0; oi < fs.length; oi++) {
              if (oi === fi) continue;
              if (sel[oi] != null && opts[oi] !== sel[oi]) return false;
            }
            return v.available;
          });
          l.classList.toggle('atleqs-soldout', !ok);
        });
      });
      if (!best) return;
      var idInp = wrap.querySelector('form [name="id"]');
      if (idInp) idInp.value = best.id;
      var pw = wrap.querySelector('.price');
      if (pw) {
        var saleEl = pw.querySelector('.price-item--sale');
        var regs = pw.querySelectorAll('.price-item--regular');
        if (saleEl) saleEl.textContent = euro(best.price);
        regs.forEach(function (r2) { r2.textContent = euro(best.compare_at_price && best.compare_at_price > best.price ? best.compare_at_price : best.price); });
      }
      var btn = wrap.querySelector('.product-form__submit');
      if (btn) {
        if (best.available) { btn.removeAttribute('disabled'); } else { btn.setAttribute('disabled', ''); }
        var sp = btn.querySelector('span');
        if (sp) { var t2 = best.available ? 'In den Warenkorb legen' : 'Ausverkauft'; if (sp.textContent.trim() !== t2) sp.textContent = t2; }
      }
      if (best.featured_image && best.featured_image.src) {
        var img = document.querySelector('.product__media-wrapper img, .product__media img');
        if (img) { img.src = best.featured_image.src; img.removeAttribute('srcset'); }
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', best.id); history.replaceState({}, '', u.pathname + u.search); } catch (e3) {}
    };
    if (pdpCache) { done(pdpCache); }
    else { fetch(location.pathname.replace(/\/$/, '') + '.js').then(function (r3) { return r3.json(); }).then(function (pj) { pdpCache = pj; done(pj); }); }
  }
  function decorateProduct() {
    var wrap = document.querySelector('.product__info-wrapper');
    if (!wrap) return;
    wrap.querySelectorAll('fieldset').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (!lg) return;
      var nm = (lg.childNodes[0] ? lg.childNodes[0].textContent : lg.textContent).trim().toLowerCase();
      var labels = Array.prototype.slice.call(fs.querySelectorAll('label'));
      if (nm.indexOf('farbe') === 0 || nm.indexOf('color') === 0 || nm.indexOf('renk') === 0) {
        labels.forEach(function (l) {
          if (!l.classList.contains('atleqs-pswatch')) {
            l.classList.add('atleqs-pswatch');
            var inp0 = l.htmlFor ? document.getElementById(l.htmlFor) : null;
            var val = ((inp0 ? inp0.value : l.textContent) || '').trim().toLowerCase();
            var col = COLORS[val];
            l.style.background = col || '#cfcfcf';
            if (col === '#ffffff') l.style.boxShadow = 'inset 0 0 0 1px rgba(18,18,18,.25)';
            l.title = (l.textContent || '').trim();
          }
        });
      } else if (nm.indexOf('gr') === 0 || nm.indexOf('size') === 0 || nm.indexOf('boyut') === 0 || nm.indexOf('beden') === 0) {
        labels.forEach(function (l) { l.classList.add('atleqs-psize'); });
      } else { return; }
      if (!lg.querySelector('.atleqs-legend-val')) {
        var sp = document.createElement('span');
        sp.className = 'atleqs-legend-val';
        lg.appendChild(sp);
      }
      updLegend(fs, lg);
    });
    if (!document.body.hasAttribute('data-atleqs-pdp-hooked')) {
      document.body.setAttribute('data-atleqs-pdp-hooked', '1');
      var pdpStop = function (ev) {
        var inp = ev.target;
        if (!inp || inp.type !== 'radio') return;
        if (!inp.closest('.product__info-wrapper')) return;
        if (inp.closest('quick-add-modal')) return;
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        if (ev.type === 'change') { quietUpdatePdp(); }
      };
      document.addEventListener('change', pdpStop, true);
      document.addEventListener('input', pdpStop, true);
    }
  }
  function decorateFacets() {
    document.querySelectorAll('#main-collection-filters details').forEach(function (d) {
      var sum = d.querySelector('summary'); if (!sum) return;
      var nm = sum.textContent.trim().toLowerCase();
      var isColor = nm.indexOf('farbe') === 0;
      var isSize = nm.indexOf('gr') === 0;
      if (!isColor && !isSize) return;
      d.setAttribute('open', '');
      var ul = d.querySelector('ul');
      if (ul) ul.classList.add(isColor ? 'atleqs-facet-colors' : 'atleqs-facet-sizes');
      d.querySelectorAll('label.facet-checkbox').forEach(function (l) {
        var inp = l.querySelector('input[type="checkbox"]'); if (!inp) return;
        if (isColor) {
          if (!l.classList.contains('atleqs-fswatch')) {
            l.classList.add('atleqs-fswatch');
            var col = COLORS[(inp.value || '').trim().toLowerCase()];
            l.style.background = col || '#cfcfcf';
            if (col === '#ffffff') l.style.boxShadow = 'inset 0 0 0 1px rgba(18,18,18,.25)';
            l.title = inp.value;
          }
          l.classList.toggle('is-active', inp.checked);
        } else {
          l.classList.add('atleqs-fsize');
          l.setAttribute('data-val', inp.value);
          l.classList.toggle('is-active', inp.checked);
        }
      });
    });
  }
  document.addEventListener('click', function (e) {
    var mwHit = e.target.closest ? e.target.closest('quick-add-modal .product__media-wrapper') : null;
    if (mwHit) { e.preventDefault(); e.stopPropagation(); openLightbox(mwHit); return; }
    var wrap = e.target.closest ? e.target.closest('.card-wrapper') : null;
    if (wrap && !e.target.closest('.atleqs-atc') && !e.target.closest('quick-add-modal')) {
      var iconEl = wrap.querySelector('.atleqs-atc');
      if (iconEl) {
        var rr = iconEl.getBoundingClientRect();
        if (e.clientX >= rr.left && e.clientX <= rr.right && e.clientY >= rr.top && e.clientY <= rr.bottom) {
          e.preventDefault(); e.stopPropagation();
          iconEl.click();
          return;
        }
      }
    }
    var sw = e.target.closest('.atleqs-swatch, .atleqs-size');
    if (sw) {
      e.preventDefault(); e.stopPropagation();
      var card = cardOf(sw); if (!card) return;
      var group = sw.classList.contains('atleqs-swatch') ? '.atleqs-swatch' : '.atleqs-size';
      card.querySelectorAll(group).forEach(function (b) { b.classList.remove('is-active'); });
      sw.classList.add('is-active');
      document.querySelectorAll('.atleqs-detail.is-visible').forEach(function (d) { if (!card.contains(d)) d.classList.remove('is-visible'); });
      updateCard(card);
      return;
    }
    var atc = e.target.closest('.atleqs-atc');
    if (atc) {
      e.preventDefault(); e.stopPropagation();
      var card2 = cardOf(atc);
      var qbtn = card2 ? card2.querySelector('modal-opener .quick-add__submit, .quick-add__submit') : null;
      if (qbtn) {
        var vid = atc.getAttribute('data-variant-id');
        var hasSel = card2.querySelector('.atleqs-swatch.is-active') || card2.querySelector('.atleqs-size.is-active');
        var pu = qbtn.getAttribute('data-product-url');
        if (pu && vid && hasSel) { qbtn.setAttribute('data-product-url', pu.split('?')[0] + '?variant=' + vid); }
        qbtn.click();
        [50, 150, 300, 600, 1000, 1600, 2200].forEach(function (t) { setTimeout(decorateQuickAdd, t); });
        return;
      }
      var id = atc.getAttribute('data-variant-id');
      if (!id) return;
      atc.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed ' + r.status);
        return r.json();
      }).then(function (data) {
        atc.classList.add('is-added');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
          try { drawer.renderContents(data); } catch (err) { refreshCartBadge(); }
        } else { refreshCartBadge(); }
        setTimeout(function () { atc.classList.remove('is-added'); atc.disabled = false; }, 1500);
      }).catch(function () { atc.disabled = false; });
    }
  }, true);
  function initCards() {
    paintSwatches();
    document.querySelectorAll('.card-wrapper').forEach(function (c) { if (getData(c)) markSoldout(c); });
    decorateProduct();
    decorateFacets();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else { initCards(); }
  [2000, 4000, 7000].forEach(function (t) { setTimeout(initCards, t); });
  /* ATLEQS FIX Bug2: Farbpillen in nachgeladenen Bereichen (Weitere Angebote) neu einfaerben */
  new MutationObserver(function () { clearTimeout(window.__atlqSw); window.__atlqSw = setTimeout(paintSwatches, 150); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  ['change', 'click', 'input'].forEach(function (evn) {
    document.addEventListener(evn, function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('facet-filters-form, .active-facets')) {
        var sy = window.scrollY;
        [80, 200, 400, 800, 1600, 2600].forEach(function (t) { setTimeout(function () { initCards(); if (Math.abs(window.scrollY - sy) > 4) window.scrollTo(0, sy); }, t); });
      }
    });
  });
})();
/* ATLEQS N2 Farbpillen max 3 + '+N' auf Karten (web+mobil; Systempfleger 16.07.2026) */
!function(){function lim(){document.querySelectorAll('.card-wrapper .atleqs-swatches').forEach(function(g){var sw=Array.prototype.slice.call(g.querySelectorAll('.atleqs-swatch'));if(sw.length>3&&!g.querySelector('.atleqs-more')){sw.slice(3).forEach(function(s){s.style.display='none';});var m=document.createElement('span');m.className='atleqs-more';m.textContent='+'+(sw.length-3);g.appendChild(m);}});}document.addEventListener('DOMContentLoaded',lim);lim();new MutationObserver(function(){clearTimeout(window.__atlqLim);window.__atlqLim=setTimeout(lim,200);}).observe(document.body||document.documentElement,{childList:true,subtree:true});}();
/* ATLEQS N5 Hilfeseiten-Titel ausblenden (nur /pages/hilfeseite; Systempfleger 16.07.2026) */
!function(){function h(){if(location.pathname.indexOf('/pages/hilfeseite')!==0)return;var t=document.querySelector('.main-page-title');if(t)t.style.display='none';}document.addEventListener('DOMContentLoaded',h);h()}();
/* ATLEQS N6 Farbnamen TR/EN fuer Pillen (Systempfleger 16.07.2026) */
!function(){var M={'siyah':'#121212','beyaz':'#ffffff','bej':'#d9c7a7','gri':'#8a8a8a','lacivert':'#1f2a44','black':'#121212','white':'#ffffff','beige':'#d9c7a7','grey':'#8a8a8a','gray':'#8a8a8a','navy':'#1f2a44'};function p(){document.querySelectorAll('.atleqs-swatch span[data-color]').forEach(function(el){var k=(el.getAttribute('data-color')||'').toLowerCase();var c=M[k];if(c&&!el.style.background){el.style.background=c;if(c==='#ffffff')el.style.boxShadow='inset 0 0 0 1px rgba(18,18,18,.2)';}});}document.addEventListener('DOMContentLoaded',p);p();new MutationObserver(function(){clearTimeout(window.__atlqN6);window.__atlqN6=setTimeout(p,200);}).observe(document.body||document.documentElement,{childList:true,subtree:true});}();
/* ATLEQS N7 Locale-Praefix fuer interne Links (verhindert Sprach-Verlust; Systempfleger 16.07.2026) */
!function(){function fx(){var rt=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';if(rt==='/')return;var base=rt.replace(/\/$/,'');document.querySelectorAll('a[href^="/"]').forEach(function(a){var h=a.getAttribute('href');if(!h||h.indexOf(base+'/')===0||h===base)return;if(/^\/(cdn|checkouts|admin|apps|payments|tools)\b/.test(h))return;a.setAttribute('href',base+h);});}document.addEventListener('DOMContentLoaded',fx);fx();new MutationObserver(function(){clearTimeout(window.__atlqN7);window.__atlqN7=setTimeout(fx,250);}).observe(document.body||document.documentElement,{childList:true,subtree:true});}();
/* ATLEQS N8 Karten-Farbpillen sprachfest bauen (nur lokalisierte Sprachen; Systempfleger 16.07.2026) */
!function(){var C={siyah:'#121212',schwarz:'#121212',black:'#121212',beyaz:'#ffffff',weiss:'#ffffff','weiß':'#ffffff',white:'#ffffff',bej:'#d9c7a7',beige:'#d9c7a7',gri:'#8a8a8a',grau:'#8a8a8a',grey:'#8a8a8a',gray:'#8a8a8a',lacivert:'#1f2a44',marine:'#1f2a44',navy:'#1f2a44',kirmizi:'#c0392b','kırmızı':'#c0392b',rot:'#c0392b',red:'#c0392b',mavi:'#2c5aa0',blau:'#2c5aa0',blue:'#2c5aa0',yesil:'#3f7d4e','yeşil':'#3f7d4e',gruen:'#3f7d4e','grün':'#3f7d4e',green:'#3f7d4e',sari:'#e0b93a','sarı':'#e0b93a',gelb:'#e0b93a',yellow:'#e0b93a',pembe:'#e79bb5',rosa:'#e79bb5',pink:'#e79bb5',mor:'#7d5ba6',lila:'#7d5ba6',purple:'#7d5ba6',turuncu:'#e08a3a',orange:'#e08a3a',kahverengi:'#6b4a2b',braun:'#6b4a2b',brown:'#6b4a2b'};function n(s){return (s==null?'':''+s).trim().toLowerCase();}function build(card){if(card.querySelector('.atleqs-swatches'))return;var sc=card.querySelector('script[type="application/json"]');if(!sc)return;var a;try{a=JSON.parse(sc.textContent);}catch(e){return;}if(!Array.isArray(a)||!a.length)return;var best=null,bh=-1;['o1','o2','o3'].forEach(function(k){var seen={},v=[];a.forEach(function(x){var y=x[k];if(y!=null&&!seen[y]){seen[y]=1;v.push(y);}});var hit=v.filter(function(y){return C[n(y)];}).length;if(hit>bh){bh=hit;best=k;}});if(!best||bh<1)return;var seen={},cols=[],av={};a.forEach(function(x){var y=x[best];if(y==null)return;av[y]=av[y]||!!x.a;if(!seen[y]){seen[y]=1;cols.push(y);}});if(!cols.length)return;var hs=card.querySelectorAll('.card__heading');var h=hs[hs.length-1];if(!h||!h.parentNode)return;var wrap=document.createElement('div');wrap.className='atleqs-swatches';cols.slice(0,3).forEach(function(cn){var sp=document.createElement('span');sp.className='atleqs-swatch';sp.style.opacity=av[cn]?'1':'.35';var i=document.createElement('span');i.setAttribute('data-color',n(cn));var hx=C[n(cn)]||'#cccccc';i.style.background=hx;if(hx==='#ffffff')i.style.boxShadow='inset 0 0 0 1px rgba(18,18,18,.2)';sp.appendChild(i);wrap.appendChild(sp);});if(cols.length>3){var m=document.createElement('span');m.className='atleqs-more';m.textContent='+'+(cols.length-3);wrap.appendChild(m);}h.parentNode.insertBefore(wrap,h);}function run(){if(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')==='/')return;document.querySelectorAll('.card-wrapper').forEach(build);}document.addEventListener('DOMContentLoaded',run);run();new MutationObserver(function(){clearTimeout(window.__atlqB);window.__atlqB=setTimeout(run,250);}).observe(document.body||document.documentElement,{childList:true,subtree:true});}();
/* ATLEQS N9 Promo+USP Texte TR/EN (nur .atleqs-promo/.atleqs-usp; server-Sektionen sind Custom-Liquid ohne uebersetzbare Settings; Systempfleger 16.07.2026) */
!function(){var T={tr:{'Unterwäsche für Damen':'Kadın İç Giyim','Unterwäsche für Männer':'Erkek İç Giyim','Unsere Kollektion für Damen.':'Kadınlara özel koleksiyonumuz.','Unsere Kollektion für Herren.':'Erkeklere özel koleksiyonumuz.','Jetzt shoppen':'Şimdi alışveriş yap','30 Tage Rückgabe':'30 Gün İade','Kaufe sorglos – du hast 30 Tage Zeit, deine Bestellung zurückzusenden.':'Gönül rahatlığıyla alışveriş yap – siparişini iade etmek için 30 günün var.','Kostenloser Versand':'Ücretsiz Kargo','Schnelle Lieferung mit zuverlässigen Versandpartnern – ohne Mindestbestellwert.':'Güvenilir kargo partnerleriyle hızlı teslimat – minimum sepet tutarı yok.','Sicher bezahlen':'Güvenli Ödeme','Verschlüsselte Zahlungen, die deine Daten bei jedem Schritt schützen.':'Verilerini her adımda koruyan şifreli ödemeler.','Premium-Materialien':'Premium Malzemeler','Sorgfältig ausgewählte Stoffe für Komfort und Langlebigkeit.':'Konfor ve dayanıklılık için özenle seçilmiş kumaşlar.'},en:{'Unterwäsche für Damen':'Underwear for Women','Unterwäsche für Männer':'Underwear for Men','Unsere Kollektion für Damen.':'Our collection for women.','Unsere Kollektion für Herren.':'Our collection for men.','Jetzt shoppen':'Shop now','30 Tage Rückgabe':'30-Day Returns','Kaufe sorglos – du hast 30 Tage Zeit, deine Bestellung zurückzusenden.':'Shop worry-free – you have 30 days to return your order.','Kostenloser Versand':'Free Shipping','Schnelle Lieferung mit zuverlässigen Versandpartnern – ohne Mindestbestellwert.':'Fast delivery with reliable shipping partners – no minimum order value.','Sicher bezahlen':'Secure Payment','Verschlüsselte Zahlungen, die deine Daten bei jedem Schritt schützen.':'Encrypted payments that protect your data at every step.','Premium-Materialien':'Premium Materials','Sorgfältig ausgewählte Stoffe für Komfort und Langlebigkeit.':'Carefully selected fabrics for comfort and durability.'}};function loc(){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';if(r.indexOf('/tr')===0)return 'tr';if(r.indexOf('/en')===0)return 'en';return null;}function swap(){var L=loc();if(!L)return;var M=T[L];document.querySelectorAll('.atleqs-promo, .atleqs-usp').forEach(function(sec){var w=document.createTreeWalker(sec,NodeFilter.SHOW_TEXT);var n;while((n=w.nextNode())){var t=n.textContent.trim();if(M[t]){n.textContent=n.textContent.replace(t,M[t]);}}});}document.addEventListener('DOMContentLoaded',swap);swap();new MutationObserver(function(){clearTimeout(window.__atlqN9);window.__atlqN9=setTimeout(swap,250);}).observe(document.body||document.documentElement,{childList:true,subtree:true});}();
/* ATLEQS N11 Desktop-Drag-Slide fuer Produkt-Slider (alle Sprachen; Systempfleger 17.07.2026) */
!function(){if(!window.matchMedia||!matchMedia('(pointer:fine)').matches)return;function arm(u){if(u.__atlqDrag)return;u.__atlqDrag=1;var down=false,moved=false,sx=0,sl=0;u.addEventListener('pointerdown',function(e){if(e.button!==0)return;down=true;moved=false;sx=e.clientX;sl=u.scrollLeft;});u.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-sx;if(Math.abs(dx)>5){moved=true;u.scrollLeft=sl-dx;e.preventDefault();}});['pointerup','pointerleave','pointercancel'].forEach(function(ev){u.addEventListener(ev,function(){down=false;setTimeout(function(){moved=false;},0);});});u.addEventListener('dragstart',function(e){if(down||moved)e.preventDefault();});u.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);u.style.cursor='grab';}
function run(){document.querySelectorAll('slider-component ul.product-grid').forEach(arm);}document.addEventListener('DOMContentLoaded',run);run();new MutationObserver(function(){clearTimeout(window.__atlqN11);window.__atlqN11=setTimeout(run,300);}).observe(document.body||document.documentElement,{childList:true,subtree:true});}();